export class Ced {
  id: number;
  code: string;
  danger: boolean;
  libelle: string;
  niveauCED: string;
  displayCode: string;
  constructor(id: number, code: string, danger: boolean, libelle: string, niveauCED: string, displayCode: string) {
    this.id = id;
    this.code = code;
    this.danger = danger;
    this.libelle = libelle;
    this.niveauCED = niveauCED;
    this.displayCode = displayCode;
  }
}
